module.exports = __webpack_public_path__ + "img/google-maps.8821375c.svg";